import React from "react";
import { Link } from 'react-router-dom';
import './back-button.css';

const BackButton = () => {
    return (
        <Link className="back-button" to="/">Back</Link>
    );
}

export default BackButton;